import {
  LOGIN_DIALOG_OPEN,
  LOGIN_DIALOG_CLOSE,
  REMOTE_DIALOG_CLOSE,
  REMOTE_DIALOG_OPEN
} from 'types/actions/login-dialog'

const loginDialogInitialState = {
  open: false,
  remoteControl: false
}

export default (state = loginDialogInitialState, action) => {
  switch (action.type) {
    case LOGIN_DIALOG_OPEN:
    case LOGIN_DIALOG_CLOSE:
      return {
        ...state,
        open: action.open
      }
    case REMOTE_DIALOG_CLOSE:
      return {
        ...state,
        remoteControl: action.remoteControl
      }
    case REMOTE_DIALOG_OPEN:
      return {
        ...state,
        remoteControl: action.remoteControl
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/login-dialog.js